import { render, staticRenderFns } from "./log_weight_card.vue?vue&type=template&id=ab21b448&scoped=true&lang=html&"
import script from "./log_weight_card.vue?vue&type=script&lang=js&"
export * from "./log_weight_card.vue?vue&type=script&lang=js&"
import style0 from "./log_weight_card.vue?vue&type=style&index=0&id=ab21b448&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab21b448",
  null
  
)

export default component.exports